/* Kosárba tétel visszajelzése mobilon — alsó sáv a teljes képernyős
   drawer helyett.

   MIÉRT: a megbízó jelezte, hogy mobilon a kosárba tétel után a teljes
   képernyős kosár-drawer beugrik, ami kizökkenti a böngészésből. Helyette
   egy rövid ideig látszó alsó sáv jelzi, hogy a termék bekerült, és
   megmutatja, mennyi hiányzik még az ingyenes szállításig.

   HOGYAN: a natív drawer a `cart:update` eseményre nyílik, ha van rajta
   `auto-open` attribútum (assets/cart-drawer.js). Mobilon ezt levesszük,
   így a drawer nem veszi át a képernyőt; desktopon érintetlen marad.

   A MARKUPOT IS EZ A FÁJL ÉPÍTI — a miértjét ld. a
   snippets/pm-cart-toast.liquid megjegyzésében: a szerver-oldalon
   renderelt elemet a kosárművelet utáni szekció-újrarenderelés kicseréli
   a JS keze alatt. A body-hoz fűzött, JS által épített elemet ez nem éri
   el.

   A küszöb a snippetből jön (window.pmCartToast), és megegyezik a
   snippets/cart-products.liquid ingyenes-szállítás sávjáéval. */
(function () {
  'use strict';

  /* 2026-11-02 (a megbízó: tableten még beugrik a kosár): az érintőképernyős
     tablet is sávot kap, szélességtől függetlenül. Egérrel használt kis
     laptopon marad a drawer. Ugyanez a feltétel kell a snippet CSS-ébe és az
     assets/pm-mehecske.js-be. */
  var MOBIL = '(max-width: 767px), (hover: none) and (pointer: coarse)';
  var LATHATO_MS = 5000;

  var beallitas = window.pmCartToast || {};
  var kuszob = beallitas.threshold || 0;
  var kosarUrl = beallitas.cartUrl || '/cart';
  var meheSvg = beallitas.beeSvg || '';

  function mobil() {
    return window.matchMedia(MOBIL).matches;
  }

  function penz(cents) {
    if (window.pmMoney && window.pmMoney.formatHuf) return window.pmMoney.formatHuf(cents);
    return Math.round(cents / 100) + ' Ft';
  }

  // ---- markup -----------------------------------------------------------

  var MEH_RAJZ = '<svg viewBox="0 0 28 28" width="22" height="22" aria-hidden="true">' +
    '<g class="pm-cart-toast__szarny pm-cart-toast__szarny--bal"><ellipse cx="9.5" cy="8.5" rx="5.5" ry="3.4" fill="rgba(255,252,245,.9)" stroke="#8A6B2E" stroke-width=".8"/></g>' +
    '<g class="pm-cart-toast__szarny pm-cart-toast__szarny--jobb"><ellipse cx="18.5" cy="8.5" rx="5.5" ry="3.4" fill="rgba(255,252,245,.9)" stroke="#8A6B2E" stroke-width=".8"/></g>' +
    '<ellipse cx="14" cy="16.5" rx="8.5" ry="5.8" fill="#E9B434" stroke="#3A2405" stroke-width="1"/>' +
    '<path d="M9.6 12v9M13.5 10.9v11.2M17.4 12v9" stroke="#3A2405" stroke-width="2" stroke-linecap="round"/>' +
    '<circle cx="22.4" cy="15.2" r="2.8" fill="#3A2405"/>' +
    '</svg>';

  var sav = document.createElement('div');
  sav.className = 'pm-cart-toast';
  sav.id = 'pm-cart-toast';
  sav.innerHTML =
    '<div class="pm-cart-toast__top">' +
      '<span class="pm-cart-toast__check" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"></path></svg>' +
      '</span>' +
      '<p class="pm-cart-toast__count"></p>' +
      '<a class="pm-cart-toast__link"></a>' +
      '<button type="button" class="pm-cart-toast__close" aria-label="Bezárás">' +
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"></path></svg>' +
      '</button>' +
    '</div>' +
    '<p class="pm-cart-toast__ship"></p>' +
    /* 2026-09-13: a meh es a leszallasi pont a SAVON BELUL ul, hogy a savhoz
       kepest lehessen pozicionalni (ld. a snippet CSS-eben). A rajz a
       Kosarba gomb mehe (blocks/pm-quick-add.liquid) — sotet test, vilagos
       szarny, ami a zoldon latszik; a korabbi vonalas ikon a csikkal azonos
       sargaban gyakorlatilag lathatatlan volt (a megbizo jelezte). */
    /* A csik egy vago keretben (.pm-cart-toast__csik, overflow hidden)
       teljes szelessegu, es transform-mal csuszik be: a width-atmenet
       layout volt, a foszalon futott, es a fiok frissitesevel egy idoben
       akadozott (a megbizo jelezte). A keret kell, mert a sav maga
       overflow: visible (a meh es a zaro pont miatt). */
    '<div class="pm-cart-toast__bar"><span class="pm-cart-toast__csik"><i></i></span>' +
      '<span class="pm-cart-toast__veg" aria-hidden="true"></span>' +
      '<span class="pm-cart-toast__bee" aria-hidden="true">' + MEH_RAJZ + '</span>' +
    '</div>';

  var szovegEl = sav.querySelector('.pm-cart-toast__count');
  var szallitasEl = sav.querySelector('.pm-cart-toast__ship');
  var savDoboz = sav.querySelector('.pm-cart-toast__bar');
  var savCsik = savDoboz.querySelector('i');

  /* KÜLÖN bemondó a képernyőolvasónak. A sáv maga `visibility: hidden`
     állapotban kapja meg a szövegét, és csak egy képkockával később válik
     láthatóvá — egy NEM renderelt élő régió változását viszont a
     képernyőolvasók nem jelentik be, a későbbi láthatóvá válás pedig már
     nem szövegváltozás. Ezért a `role="status"` nem a sávon van, hanem
     ezen a mindig renderelt, csak vizuálisan rejtett elemen. */
  var bemondo = document.createElement('div');
  bemondo.setAttribute('role', 'status');
  bemondo.setAttribute('aria-live', 'polite');
  bemondo.style.cssText =
    'position:absolute;width:1px;height:1px;margin:-1px;padding:0;' +
    'overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';

  /* A méhecske méretét attribútumban is rögzítjük, ne csak CSS-ben: a
     blokk-stíluslap később érkezhet, mint ahogy ez az elem elkészül, és
     méret nélkül az SVG az alapértelmezett 300px-en villanna fel (ez a
     hiba a blocks/review.liquid csillagánál már megtörtént). */
  var meheSvgEl = sav.querySelector('.pm-cart-toast__bee svg');
  if (meheSvgEl) {
    meheSvgEl.setAttribute('width', '22');
    meheSvgEl.setAttribute('height', '22');
    meheSvgEl.style.display = 'block';
  }

  var link = sav.querySelector('.pm-cart-toast__link');
  link.setAttribute('href', kosarUrl);
  link.textContent = 'Kosár megtekintése';

  sav.querySelector('.pm-cart-toast__close').addEventListener('click', elrejt);

  function beszur() {
    if (!document.body) return;
    if (sav.parentElement !== document.body) document.body.appendChild(sav);
    if (bemondo.parentElement !== document.body) document.body.appendChild(bemondo);
  }

  if (document.body) beszur();
  else document.addEventListener('DOMContentLoaded', beszur);

  // ---- a natív drawer elnémítása mobilon --------------------------------

  /* Az eredeti állapotot megjegyezzük, hogy egy átméretezés ne kapcsolja
     be olyan boltban, ahol az auto-open eleve ki volt kapcsolva. */
  var eredetiAutoOpen = (function () {
    var d = document.querySelector('cart-drawer-component');
    return d ? d.hasAttribute('auto-open') : false;
  })();

  function drawerAllapot() {
    if (!eredetiAutoOpen) return;
    document.querySelectorAll('cart-drawer-component').forEach(function (d) {
      if (mobil()) d.removeAttribute('auto-open');
      else d.setAttribute('auto-open', '');
    });
  }

  function drawerDialogus() {
    var d = document.querySelector('cart-drawer-component');
    return d ? d.querySelector('dialog') : null;
  }

  var drawerNyitvaVolt = false;

  /* Az attribútum EGYSZERI levétele nem elég: a téma a kosárműveletek
     után újrarendereli a szekciókat, és az új cart-drawer-component
     megint megkapja az `auto-open`-t (mérve: a második hozzáadásnál a
     drawer újra megnyílt). Ezért a `cart:update`-re LEFOGÓ (capture)
     fázisban is levesszük — a capture a documenten hamarabb fut, mint a
     drawer saját, buborékoló kezelője, tehát az már attribútum nélkül
     találja magát. */
  document.addEventListener('cart:update', function () {
    var dlg = drawerDialogus();
    drawerNyitvaVolt = !!(dlg && dlg.open);
    drawerAllapot();
  }, true);

  /* Biztonsági háló a fenti sorrend-feltevés mellé. A capture csak akkor
     előzi meg a drawert, ha az esemény célpontja egy leszármazott elem —
     a sections/pm-sticky-cart-bar.liquid viszont KÖZVETLENÜL a
     documenten dispatch-el, és ott a listenerek regisztrációs sorrendben
     futnak. Mérve ma a mi kezelőnk fut előbb, de ez a téma egy
     frissítésével megfordulhat, ezért ha a drawer mégis kinyílna, mobilon
     becsukjuk. Csak akkor, ha az esemény ELŐTT még csukva volt: aki maga
     nyitotta ki a drawert és ott módosít mennyiséget, annak ne csukjuk be
     az orra előtt. */
  function drawerBezarHaKell() {
    if (!mobil() || drawerNyitvaVolt) return;
    var d = document.querySelector('cart-drawer-component');
    var dlg = d && d.querySelector('dialog');
    if (!dlg || !dlg.open) return;
    if (typeof d.closeDialog === 'function') d.closeDialog();
    else dlg.close();
  }

  // ---- megjelenítés ------------------------------------------------------

  var utolsoDb = null;
  var idozito = null;
  var leszallasIdozito = null;

  var fuggoben = false;

  function elrejt() {
    fuggoben = false;
    sav.classList.remove('is-visible');
  }

  /* 2026-11-02 (a megbízó videója, tablet): a méh 1,5 mp alatt leszáll, a
     szerver válasza viszont lassú netnél ennél később jön, így a méh egy még
     láthatatlan sávra szállt, és a semmiben tűnt el. A sáv ezért a leszálláskor
     megjelenik, a darabszámot a mutat() írja be, amint megjött a válasz. */
  document.addEventListener('pm:meh-leszallt', function () {
    if (!mobil()) return;
    beszur();
    fuggoben = true;
    szovegEl.textContent = 'Kosárba teszem…';
    szallitasEl.textContent = '';
    sav.classList.add('is-visible');
    if (idozito) clearTimeout(idozito);
    idozito = setTimeout(elrejt, 8000);
  });

  document.addEventListener('pm:kosar-hiba', function () {
    if (fuggoben) elrejt();
  });

  function mutat(kosar) {
    if (!mobil()) return;
    beszur();
    fuggoben = false;

    var db = kosar.item_count || 0;
    var dbSzoveg = db === 1 ? '1 termék a kosárban' : db + ' termék a kosárban';
    szovegEl.textContent = dbSzoveg;
    var szallitasSzoveg = '';

    if (kuszob > 0) {
      var hianyzik = kuszob - (kosar.total_price || 0);
      if (hianyzik <= 0) {
        szallitasSzoveg = 'Ingyenes szállítást értél el.';
        /* A sáv marad, teli aranyban — a "megvan" állapot visszajelzése.
           Fölötte repül át a méhecske; az osztályt előbb levesszük és egy
           kényszerített újraszámolás után tesszük vissza, különben egy
           újabb hozzáadásnál a már lefutott animáció nem indulna újra. */
        savDoboz.hidden = false;
        /* A repules hosszat itt merjuk ki, nem a CSS-ben vw-bol: a vw a
           gorgetosavot is beleszamolja (merve 10-16px tulfutas).
           A meh a sav vegen szall le: az ut a sav belso szelessege minusz a
           22px-es rajz nagyja, hogy a teste a zaro pont fole erjen. */
        sav.style.setProperty('--pm-bee-ut', Math.max(0, savDoboz.clientWidth - 20) + 'px');
        sav.classList.remove('pm-cart-toast--ingyenes');
        sav.classList.remove('pm-cart-toast--leszallt');
        void sav.offsetWidth;
        sav.classList.add('pm-cart-toast--ingyenes');
        /* A szelesseg az osztaly UTAN: igy a csik az 1,5 mp-es atmenettel,
           a mehhel egyutt telik be (elotte a 260 ms-os alapatmenet indult
           el, es 600 ms-nal mar tele volt — merve). */
        savCsik.style.transform = 'translateX(0)';
        /* Leszallas utan a szarnyak megallnak es a kartyan vegigfut a
           csillogas — az idozites a CSS-beli 1500ms-os repuleshez igazodik. */
        if (leszallasIdozito) clearTimeout(leszallasIdozito);
        leszallasIdozito = setTimeout(function () { sav.classList.add('pm-cart-toast--leszallt'); }, 1500);
      } else {
        szallitasSzoveg = 'Még ' + penz(hianyzik) + ' hiányzik az ingyenes szállításhoz.';
        sav.classList.remove('pm-cart-toast--ingyenes');
        sav.classList.remove('pm-cart-toast--leszallt');
        if (leszallasIdozito) { clearTimeout(leszallasIdozito); leszallasIdozito = null; }
        savDoboz.hidden = false;
        var szazalek = Math.max(0, Math.min(100, ((kosar.total_price || 0) / kuszob) * 100));
        savCsik.style.transform = 'translateX(' + (-(100 - szazalek)).toFixed(2) + '%)';
      }
      szallitasEl.textContent = szallitasSzoveg;
    }

    // A bemondó mindig renderelt, ezért itt tényleg elhangzik a szöveg.
    bemondo.textContent = dbSzoveg + (szallitasSzoveg ? '. ' + szallitasSzoveg : '');

    /* Az osztályt AZONNAL tesszük fel, nem requestAnimationFrame-ből: az
       rAF háttérbe került fülön nem fut le (mérve: a sáv tartalma
       frissült, az osztály viszont sosem került fel). Az átmenet így is
       lefut, mert az elem az oldal betöltése óta a DOM-ban van, a
       kiindulási állapota tehát már ki van festve. */
    sav.classList.add('is-visible');

    if (idozito) clearTimeout(idozito);
    idozito = setTimeout(elrejt, LATHATO_MS);
  }

  function kosarLekeres() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* A kiindulási darabszám a fejléc kosár-buborékjából jön, AZONNAL. A
     korábbi változat egy /cart.js kérésre várt, és amíg az be nem futott,
     az `utolsoDb` null maradt — az első kosárba tétel így visszajelzés
     nélkül maradt, miközben a drawer is el van némítva, tehát a vásárló
     semmit nem látott. */
  function fejlecDb() {
    var buborek = document.querySelector('.cart-bubble');
    if (!buborek) return null;
    if (buborek.classList.contains('visually-hidden')) return 0; // üres kosár
    var el = buborek.querySelector('.cart-bubble__text-count');
    var n = el ? parseInt(String(el.textContent).replace(/\D/g, ''), 10) : NaN;
    return isFinite(n) ? n : null;
  }

  /* A darabszámot a VIEWPORTTÓL FÜGGETLENÜL vezetjük. Korábban a kezelő
     desktopon azonnal visszatért, így az `utolsoDb` elavult maradt: aki
     fekvő módban (desktop-ág) rakott be három terméket, majd álló módba
     fordította a telefont és TÖRÖLT egyet, annak a sáv felvillant a
     törlésre — pontosan az, amit el akarunk kerülni. */
  function feldolgoz(kosar) {
    if (!kosar) return;
    var db = kosar.item_count || 0;
    var nott = utolsoDb !== null && db > utolsoDb;
    utolsoDb = db;
    if (nott) mutat(kosar);
    else if (fuggoben) elrejt();
  }

  var keresSorszam = 0;

  /* A `cart:update` eseményt a hozzáadás ÉS a mennyiség-módosítás,
     törlés is kiváltja. Csak akkor jelzünk vissza, ha a darabszám NŐTT —
     így törlésnél vagy csökkentésnél nem villan fel a sáv.

     A friss kosarat az esemény `detail.resource` mezője már tartalmazza
     (assets/events.js, CartAddEvent/CartUpdateEvent), ezért nem kérjük le
     újra: a plusz kérés nemcsak felesleges volt, hanem versenyhelyzetet is
     okozott — két gyors hozzáadásnál a válaszok sorrendje felcserélődhet,
     és az `utolsoDb` egy régebbi értéken ragadt. Ha valamiért mégis
     hiányzik a payload, a tartalék lekérésnél sorszám őrzi a sorrendet. */
  document.addEventListener('cart:update', function (e) {
    var kosar = e && e.detail && e.detail.resource;
    if (kosar && typeof kosar.item_count === 'number') {
      feldolgoz(kosar);
      drawerBezarHaKell();
      return;
    }
    var sajat = ++keresSorszam;
    kosarLekeres().then(function (k) {
      if (sajat !== keresSorszam) return; // közben újabb kérés válaszolt
      feldolgoz(k);
      drawerBezarHaKell();
    });
  });

  // A drawer akár késleltetve is megnyílhat (szekció-újrarenderelés után).
  document.addEventListener('cart:update', function () {
    setTimeout(drawerBezarHaKell, 300);
  });

  drawerAllapot();
  window.addEventListener('resize', drawerAllapot);

  utolsoDb = fejlecDb();
  if (utolsoDb === null) {
    // Tartalék: ha a buborék nem olvasható, marad a lekérés.
    kosarLekeres().then(function (kosar) {
      if (utolsoDb === null) utolsoDb = kosar ? kosar.item_count || 0 : 0;
    });
  }
})();

/* 2026-09-13 (audit ANIM A7): a termeklap Kosarba gombja sikeres hozzaadas
   utan 900 ms-ig zold + pipa (CSS: .pm-atc--siker). Csak akkor, ha a
   kosar-frissites a lapon levo urlap variansat erintette. */
(function () {
  document.addEventListener('cart:update', function (e) {
    var d = (e && e.detail) || {};
    // Merve: a Horizon a sourceId-ban a variáns id-t adja, data.variantId nincs.
    var vid = (d.data && d.data.variantId) || d.sourceId;
    var form = document.querySelector('form[action*="/cart/add"]');
    var inp = form && form.querySelector('input[name="id"]');
    if (!vid || !inp || String(inp.value) !== String(vid)) return;
    // Merve: a Horizon a kosarba tetel utan tobbszor ujramorfolja az urlapot
    // es a gomb osztalyait visszaallitja - ezert a jelolo osztaly a <html>
    // elemre kerul (CSS: html.pm-atc-siker ...), 900 ms-ra.
    var html = document.documentElement;
    html.classList.add('pm-atc-siker');
    clearTimeout(html.__pmAtcT);
    html.__pmAtcT = setTimeout(function () { html.classList.remove('pm-atc-siker'); }, 900);
  });
})();
